export default __webpack_public_path__ + "static/media/thapacdaibai.4d61ff74.png";